import ErrorBoundary from "@/ui/organisms/ErrorBoundary";

import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

import { ViewAuthCallback } from "@/ui/compositionRootUI";

const PageAuthCallback = () => {
    return (
        <LayoutFullScreen>
            <LayoutFillParentCentered
                sx={{
                    backgroundColor: "white",
                }}
            >
                <ErrorBoundary>
                    <ViewAuthCallback />
                </ErrorBoundary>
            </LayoutFillParentCentered>
        </LayoutFullScreen>
    );
};

export default PageAuthCallback;
